import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import getNumberOfLayers from "../../../service/getNumberOfLayers"
import { isBuildUp, isCEM3, isMEGTRON6, isRogers } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidBoardThickness = (values: EstimateValues, boardThickness?: string) => {
  const numberOfLayers = getNumberOfLayers(values)

  switch (boardThickness) {
    case ESTIMATE_CONSTANT.板厚["0.15mm"].value:
    case ESTIMATE_CONSTANT.板厚["0.2mm"].value:
    case ESTIMATE_CONSTANT.板厚["0.3mm"].value:
      if (isRogers(values)) return false
      if (isMEGTRON6(values)) return numberOfLayers <= 2
      if (isCEM3(values)) return false
      if (isBuildUp(values)) return false
      return true

    case ESTIMATE_CONSTANT.板厚["0.4mm"].value:
      if (isRogers(values)) return false
      if (isMEGTRON6(values)) return numberOfLayers <= 4
      if (isCEM3(values)) return false
      if (isBuildUp(values)) return numberOfLayers <= 4
      return true

    case ESTIMATE_CONSTANT.板厚["0.6mm"].value:
      if (isRogers(values)) return false
      if (isMEGTRON6(values)) return numberOfLayers <= 6
      if (isCEM3(values)) return false
      if (isBuildUp(values)) return numberOfLayers <= 6
      return true

    case ESTIMATE_CONSTANT.板厚["0.8mm"].value:
      if (isRogers(values)) return false
      if (isMEGTRON6(values)) return numberOfLayers <= 8
      if (isCEM3(values)) return false
      if (isBuildUp(values)) return numberOfLayers <= 8
      return true

    case ESTIMATE_CONSTANT.板厚["1.0mm"].value:
      if (isRogers(values)) return false
      if (isMEGTRON6(values)) return numberOfLayers !== 2 && numberOfLayers !== 12
      if (isCEM3(values)) return true
      if (isBuildUp(values)) return numberOfLayers !== 12
      return true

    case ESTIMATE_CONSTANT.板厚["1.2mm"].value:
      if (isRogers(values)) return false
      if (isMEGTRON6(values)) return numberOfLayers !== 2
      if (isCEM3(values)) return false
      return true

    case ESTIMATE_CONSTANT.板厚["1.6mm"].value:
      if (isRogers(values)) return false
      if (isMEGTRON6(values)) return numberOfLayers !== 2 && numberOfLayers !== 4
      if (isCEM3(values)) return true
      return true

    case ESTIMATE_CONSTANT.板厚["1.8mm"].value:
      if (isRogers(values)) return false
      if (isMEGTRON6(values)) return numberOfLayers >= 6
      if (isCEM3(values)) return false
      return numberOfLayers >= 4

    case ESTIMATE_CONSTANT.板厚["2.0mm"].value:
    case ESTIMATE_CONSTANT.板厚["2.4mm"].value:
      if (isRogers(values)) return false
      if (isMEGTRON6(values)) return numberOfLayers !== 2 && numberOfLayers !== 4 && numberOfLayers !== 6
      if (isCEM3(values)) return false
      return true

    case ESTIMATE_CONSTANT.板厚["3.0mm"].value:
      if (isRogers(values)) return false
      if (isMEGTRON6(values)) return numberOfLayers !== 2 && numberOfLayers !== 4 && numberOfLayers !== 6
      if (isCEM3(values)) return false
      if (isBuildUp(values)) return numberOfLayers >= 10
      return true

    case ESTIMATE_CONSTANT.板厚["0.25mm（Rogers材）"].value:
    case ESTIMATE_CONSTANT.板厚["0.5mm（Rogers材）"].value:
    case ESTIMATE_CONSTANT.板厚["0.76mm（Rogers材）"].value:
      return isRogers(values)

    default:
      return false
  }
}

export default isValidBoardThickness
